import IntensitySlider from './IntensitySlider';

export default IntensitySlider;
